module.exports = __webpack_public_path__ + "img/map-menu-6@2x.e54b9b29.png";